import React, { memo } from 'react';
import { TableRow, TableCell } from '@mui/material';
import { HStack, Skeleton } from 'native-base';
const TaskRowSkeleton = ({
  bgColor
}) => {
  return /*#__PURE__*/React.createElement(TableRow, {
    style: {
      height: 93,
      border: '1px solid lightBlue.400',
      backgroundColor: bgColor
    }
  }, /*#__PURE__*/React.createElement(TableCell, {
    align: "center"
  }, /*#__PURE__*/React.createElement(HStack, {
    space: 1,
    alignItems: 'center',
    justifyContent: 'center'
  }, /*#__PURE__*/React.createElement(Skeleton, {
    maxH: "4",
    maxW: "50%",
    startColor: "lightBlue.400",
    borderRadius: "4"
  }))), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(HStack, {
    space: 1,
    alignItems: 'center',
    justifyContent: 'center'
  }, /*#__PURE__*/React.createElement(Skeleton, {
    maxH: "4",
    maxW: "75%",
    startColor: "lightBlue.400",
    borderRadius: "4"
  }))), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(HStack, {
    space: 1,
    alignItems: 'center',
    justifyContent: 'center'
  }, /*#__PURE__*/React.createElement(Skeleton, {
    maxH: "4",
    maxW: "75%",
    startColor: "lightBlue.400",
    borderRadius: "4"
  }))), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(HStack, {
    space: 1,
    alignItems: 'center',
    justifyContent: 'center'
  }, /*#__PURE__*/React.createElement(Skeleton, {
    maxH: "4",
    maxW: "75%",
    startColor: "lightBlue.400",
    borderRadius: "4"
  }))), /*#__PURE__*/React.createElement(TableCell, {
    align: "center"
  }));
};
export default /*#__PURE__*/memo(TaskRowSkeleton);
//# sourceMappingURL=index.js.map